import { Icon } from '@iconify/react';

interface PadelCompactStepperProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  label: string;
}

export default function PadelCompactStepper({
  value,
  min,
  max,
  onChange,
  label,
}: PadelCompactStepperProps) {
  return (
    <div
      className="inline-flex items-center rounded-2xl border border-gray-200 bg-white p-1"
      aria-label={label}
    >
      <button
        type="button"
        aria-label={`Kurangi ${label}`}
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        className="flex h-8 w-8 items-center justify-center rounded-xl bg-gray-50 text-gray-500 transition-colors hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
      >
        <Icon icon="mdi:minus" className="h-4 w-4" />
      </button>
      <span className="min-w-8 text-center text-base font-extrabold text-[#0E1726]">
        {value}
      </span>
      <button
        type="button"
        aria-label={`Tambah ${label}`}
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        className="flex h-8 w-8 items-center justify-center rounded-xl bg-[#FFF5F1] text-[#FC480D] transition-colors hover:bg-[#FFEAE1] disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
      >
        <Icon icon="mdi:plus" className="h-4 w-4" />
      </button>
    </div>
  );
}
